import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delete-job-confirm" }
const _hoisted_2 = { class: "delete-job-confirm__actions" }

import AppButton from "@/components/ui-kit/button/AppButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteJobConfirmDropdown',
  emits: ["cancel", "confirm"],
  setup(__props, { emit: __emit }) {

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "delete-job-confirm__title" }, " Удалить работу? ", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "delete-job-confirm__description" }, " Вы собираетесь удалить работу без возможности восстановления ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppButton, {
        class: "delete-job-confirm__actions-button",
        type: "secondary",
        label: "Отмена",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }),
      _createVNode(AppButton, {
        class: "delete-job-confirm__actions-button",
        label: "Подтвердить",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      })
    ])
  ]))
}
}

})